<template>
  <div class="form-group col-md-6">
    <label :for="name" class="col-form-label">{{ title }}</label>
    <input type="hidden" :name="name" :value="value" />
    <div style="height: 300px">
      <ace-editor :id="name" v-model="value" @init="editorInit" lang="html"></ace-editor>
    </div>
  </div>
</template>

<script>
export default {
  name: "HtmlEditor",
  data() {
    return {
      editorOptions: {
        showGutter: true
      },
      value: this.$props.previousValue,
    }
  },
  props: {
    name: String,
    title: String,
    previousValue: {
      type: String,
      default: "",
    }
  },
  methods: {
    editorInit(editor) {
      require('ace-builds/src-min-noconflict/ext-language_tools');
      require('ace-builds/src-min-noconflict/mode-html');
      require('ace-builds/src-min-noconflict/theme-ambiance');
      editor.session.setMode("ace/mode/html");
      editor.commands.addCommand({
        name: "save",
        exec: this.save,
        bindKey: {mac: "cmd-s", win: "ctrl-s"}
      });
      editor.setOptions(this.editorOptions);
    },
  }
}
</script>

<style scoped>

</style>
